import Vue from 'vue';

// When the request succeeds
const successLookup = (cbInfo, response) => {
  // console.log('password reset OK response:');
  // console.log(response);
  if (cbInfo && cbInfo.cbSuccess) {
    cbInfo.cbSuccess(response);
  }
};

// When the request fails
const failedLookup = (cbInfo, response) => {
  // console.log('password reset error response:');
  // console.log(response);
  if (cbInfo && cbInfo.cbFail) {
    cbInfo.cbFail(response);
  }
};

export default (userid, cbInfo) => {
  const axiosOptions = {
    timeout: 10000,
    headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
    maxRedirects: 0,
    withCredentials: false,
  };
  const thisurl = `/api/v1/user/reset-password-by-id/${userid}`;
  Vue.$http.get(thisurl, axiosOptions)
   .then((response) => {
     successLookup(cbInfo, response);
   })
   .catch((error) => {
     failedLookup(cbInfo, error);
   });
};



// WEBPACK FOOTER //
// ./src/app/services/account/resetpw.js